/*
Function to check if a month/day combination is valid or not.
For instance, Feb 31 is not valid.
*/
import { getDaysInMonth } from "./getDaysInMonth";

export function isValidMonthDay({ month, day, year }) {
  if (month < 1 || month > 12) {
    return false;
  }

  const daysInMonth = getDaysInMonth({ month, year });

  return 1 <= day && day <= daysInMonth;
}
